import { useTranslation } from "react-i18next";
import {
  ContainerOutlined,
  DeleteFilled,
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  FileTextOutlined,
  FileUnknownOutlined,
  MoreOutlined,
  QuestionCircleOutlined,
  SaveOutlined,
  SettingOutlined,
  SolutionOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { Button, Dropdown, Input, message, Modal, Space, Tooltip, Typography, } from "antd";
import { isEmpty } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { routesConfig } from "../../../../config/routes";
import {
  deleteCourseUnitV2,
  downloadCourseUnit,
  publishUnit,
  putCourseUpdateUnit,
  saveTemplateToLibrary,
} from "../../../../service/course-construct";
import { HelpService } from "../../../../service/helper.service";
import { globalStore } from "../../../../stores/stores";
import { handleDownloadMoocsFile } from "../../../../utils/exportMoocsFile";
import AddLearningMaterialsReferences from "../../../drawer/add-learning-materials-references/AddLearningMaterialsReferences";
import AddLearningMaterials from "../../../drawer/add-learning-materials/AddLearningMaterials";
import EditExerciseDrawer from "../../../drawer/edit-exercise";
import ChooseLearningMaterialModal from "../../../modal/choose-learning-material/ChooseLearningMaterialModal";
import ActiveSettingsChaptersDrawer from "../../active-settings-chapters-drawer/ActiveSettingsChaptersDrawer";
import "../course-constructor/course-construct.scss";
import "./unit-card.scss";

var indexDB = require("idbcache").default;
type IProp = {
  data?: any;
  lessonDetailData?: any;
  id?: any;
  handleGetDetail: any;
  name?: string;
  setLoading?: (value: boolean) => void;
  sequenceId?: number;
};
const imgPath = "/images/";
const UnitCard = (props: IProp) => {
  const { t } = useTranslation();
  const helpService = new HelpService();
  const { reload, setReload } = globalStore()
  const { id } = useParams()
  const examType = props?.data.block[0]?.option?.form_of_review
  const typeModule = props.data.block.some((item: { module: string }) => item.module === 'quiz');
  const [cardHeader, setCardHeader] = useState<string>(props.data.name);
  const [oldName, setOldName] = useState<string>('');
  const [active, setActive] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const navigate = useNavigate();
  const [isAddLearningMaterials, setIsAddLearningMaterials] = useState<boolean>(false);
  const [isAddLearningMaterialsReference, setIsAddLearningMaterialsReference] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isUnit, setIsUnit] = useState<boolean>(false);
  const [isLesson, setIsLesson] = useState<boolean>(false);
  const [unitId, setUnitId] = useState<number | undefined>(undefined);
  const [isOpenSettingDraw, setIsOpenSettingDrawer] = useState(false);
  const [isOpenEditDraw, setIsOpenEditDrawer] = useState(false);
  const [iconCardModule, setIconCardModule] = useState<number>(props.data?.block?.[0]?.icon_type);
  const [isSaveLearningTemplate, setIsSaveLearningTemplate] = useState<boolean>(false);
  const tooltipRef = useRef<HTMLDivElement | null>(null);
  const [tooltipWidth, setTooltipWidth] = useState<number>(0);
  const [multimediaType, setMultimediaType] = useState<string>("");
  const [isSaving, setIsSaving] = useState<boolean>(false)


  const handleChangeNameUnit = async () => {
    const data = {
      name: cardHeader,
      sequenceId: props.id,
    };
    try {
      const response = await putCourseUpdateUnit(props.data.id, data).then(
        (result) => {
          props.handleGetDetail();
          message.success(t("Lưu cấu trúc thành công", "Lưu cấu trúc thành công"));
        }
      );
    } catch (error) {
    }
  };

  const handleBlur = () => {
    setActive(false);
    handleChangeNameUnit();
  };

  const handleClick = () => {
    if (!isEmpty(props.data.block) && props.data.block?.[0]?.module === "quiz") {
      indexDB.set("current-course", JSON.stringify({ name: props.data.name, parent: props.name, tabCurrent: '2' }), 1440);
      if (examType === 1) {
        navigate(`${routesConfig.addLesson}?unitId=${props.data.id}&blockId=${props.data.block?.[0]?.id}&mode=setting`, { state: { unitId: props.data.id ?? '' }, });

      }
      else {
        navigate(`/${routesConfig.courseConstruction}/${routesConfig.contentConstruction}/${routesConfig.contentCourseDetail}/${id}/${routesConfig.addTestSchedule}?unitId=${props.data.id}&blockId=${props.data.block?.[0]?.id}`)
      }
    } else {
      setUnitId(props?.data?.id);
      if (props.data.block?.[0]?.module === "reference") {
        setIsAddLearningMaterialsReference(true);
      } else {
        setIsAddLearningMaterials(true);
        setMultimediaType(props.data.block?.[0]?.module)
      }
      setIsEdit(true);
    }
  };

  const handleCloseEdit = () => {
    setIsOpenEditDrawer(false)
  }

  const handleCancel = () => {
    setCardHeader(oldName);
    setActive(false);
    setErrorMessage('');
  };

  const handleSave = () => {
    if (cardHeader) {
      Modal.confirm({
        title: t("Xác nhận lưu cấu trúc", "Xác nhận lưu cấu trúc"),
        content: `${t("Bạn có chắc chắn muốn lưu cấu trúc", "Bạn có chắc chắn muốn lưu cấu trúc")} ${cardHeader} ${t("của khóa học", "của khóa học")} ${props.name}?`,
        onOk: () => {
          handleBlur();
        },
        okText: t("Xác nhận", "Xác nhận"),
        cancelText: t("Huỷ", "Huỷ"),
        centered: true,
        icon: <ExclamationCircleOutlined style={{ color: "#1677FF" }} />,
        footer: (_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn />
            <OkBtn />
          </>
        ),
      });
    } else {
      setErrorMessage("Vui lòng nhập tên học liệu");
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCardHeader(event.target.value);
  };

  const handleDeleteUnit = async () => {
    try {
      const response = await deleteCourseUnitV2(Number(props.data.id)).then(
        (result) => {
          props.handleGetDetail();
          message.success(t("Xóa học liệu thành công", "Xóa học liệu thành công"));
        }
      );
    } catch (error) {
    }
  };

  const { confirm } = Modal;

  const showConfirm = () => {
    confirm({
      title: (
        <div className="title-container">
          <div style={{ color: "red", fontSize: "20px" }}>
            <DeleteFilled />
          </div>
          <span>{t("Bạn muốn xóa học liệu?", "Bạn muốn xóa học liệu?")}</span>
        </div>
      ),
      icon: null,
      okText: t("Xác nhận", "Xác nhận"),
      cancelText: t("Hủy", "Hủy"),
      okType: "danger",
      onOk() {
        handleDeleteUnit();
      },
      onCancel() {
      },
    });
  };

  const downloadUnit = (unitLink: string) => {
    if (unitLink) {
      const xmlHttp = new XMLHttpRequest();
      xmlHttp.onreadystatechange = () => {
        if (xmlHttp.readyState === 4 && xmlHttp.status === 200) {
          const blobUrl = window.URL.createObjectURL(xmlHttp.response);
          const e = document.createElement('a');
          e.href = blobUrl;
          e.download = blobUrl.substr(blobUrl.lastIndexOf('/') + 1);
          document.body.appendChild(e);
          e.click();
          document.body.removeChild(e);
        }
      };
      xmlHttp.responseType = 'blob';
      xmlHttp.open('GET', unitLink, true);
      xmlHttp.send(null);
    } else {
      helpService.errorMessage('Tài nguyên không tồn tại');
    }
  }

  const downloadUnitFeedback = async (id: number) => {
    await downloadCourseUnit(id).then((res: any) => {
      const link = document.createElement('a');
      link.href = res.data;
      link.download = '';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }).catch((error: any) => {
      helpService.errorMessage(error.response.data.message);
    });
  }

  const handlePublishUnit = async (unitId: number) => {
    try {
      await publishUnit(unitId);
      setReload(!reload)
      message.success(t("Xuất bản học liệu thành công!", "Xuất bản học liệu thành công!"))
    } catch (err) {
    }
  }

  const renderCourseIcon = (value: number) => {
    switch (value) {
      case 1:
        return "play-square-outline.svg";
      case 2:
        return "audio-outline.svg";
      case 3:
        return "xAPI-outline.svg";
      case 4:
        return "exercise-outline.svg";
      case 5:
        return "PDF-outline.svg";
      case 6:
        return "scorm-icon-outline.svg";
      case 7:
        return "audio-outline.svg";
      case 8:
        return "Text.png";
      case 9:
        return "reference-icon.svg";
      default:
        return '';
    }
  }

  useEffect(() => {
    if (tooltipRef.current) {
      const width = tooltipRef.current.offsetWidth;
      setTooltipWidth(width);
    }
  }, [props.data.name]);

  const renderIcon = () => {
    const type = props.data.block?.[0].icon_type
    switch (type) {
      case 1:
        return <FileTextOutlined style={{ fontSize: '14px' }} />
      case 2:
        return <QuestionCircleOutlined style={{ fontSize: '14px' }} />
      case 3:
        return <SolutionOutlined style={{ fontSize: '14px' }} />
    }
  }

  const handleSaveTemplate = async (data: any) => {
    setIsSaving(true)
    const payload = {
      id: props.data.id,
      type: "unit",
      folderId: data.folderId || undefined
    }

    try {
      await saveTemplateToLibrary(payload)
      setTimeout(() => {
        setIsSaveLearningTemplate(false)
      }, 0);
      message.success(t("Lưu mẫu học liệu thành công", "Lưu mẫu học liệu thành công"))

    } catch (error) {

    }
    finally {
      setIsSaving(false)
    }
  }
  const isQuiz = props.data?.block?.[0]?.module === "quiz";

  return (
    <>
      <div className="chapter-header">
        <div className="chapter-title">
          {
            typeModule ? renderIcon() :
              iconCardModule !== 9 ? <img
                className=''
                loading="eager"
                alt=''
                src={imgPath + renderCourseIcon(iconCardModule)}
              />
                : <ContainerOutlined />
          }
          <div>
            {!active ? (
              <Tooltip title={props.data?.name}
                overlayStyle={{ maxWidth: tooltipWidth + 20 }}
              >
                <div className="card-header"
                  ref={tooltipRef}
                >{props.data.name}
                </div>

              </Tooltip>
            ) : (
              <div>
                <Input
                  placeholder={t("Xin vui lòng nhập", "Xin vui lòng nhập")}
                  // onClick={handleActive}
                  // onBlur={handleBlur}
                  value={cardHeader}
                  onChange={handleChange}
                  className={
                    active
                      ? "course-input active-input"
                      : "course-input inactive-input"
                  }
                />
                {errorMessage ? (
                  <p className="validate-text">{errorMessage}</p>
                ) : null}
              </div>
            )}
          </div>
        </div>

        <Space>
          {!props.data?.isPublished &&
            <a className="action-course"
              onClick={() =>
                Modal.confirm({
                  title: t("Xuất bản học liệu", "Xuất bản học liệu"),
                  content:
                    t("Bạn có muốn xuất bản học liệu này?", "Bạn có muốn xuất bản học liệu này?"),
                  okText: t("Xác nhận", "Xác nhận"),
                  cancelText: t("Huỷ", "Huỷ"),
                  onOk: () => {
                    handlePublishUnit(Number(props.data.id))

                  },
                  onCancel() {
                    // Optional: Handle the cancel event
                  },
                })
              }>
              <UploadOutlined />
            </a>
          }
          <Dropdown
            menu={{
              items: [
                typeModule && {
                  key: "1",
                  label: examType === 1 ? t("Thiết lập câu hỏi", "Thiết lập câu hỏi") : t("Thiết lập lịch kiểm tra", "Thiết lập lịch kiểm tra"),
                  icon: <FileUnknownOutlined />,
                },
                {
                  key: "2",
                  label: t("Sửa học liệu", "Sửa học liệu"),
                  icon: <EditOutlined />,
                },
                {
                  key: "3",
                  label: t("Tải xuống", "Tải xuống"),
                  icon: <DownloadOutlined />,
                },
                {
                  key: "4",
                  label: t("Cài đặt hoạt động", "Cài đặt hoạt động"),
                  icon: <SettingOutlined />,
                },
                {
                  key: "5",
                  label: t("Xóa", "Xóa"),
                  icon: <DeleteOutlined />,
                  danger: true,
                },
                isQuiz && {
                  key: "6",
                  label: t("Cài đặt giám sát thi cử", "Cài đặt giám sát thi cử"),
                  icon: <SettingOutlined />,
                },
                !isQuiz &&
                {
                  key: "7",
                  label: t("Lưu mẫu học liệu", "Lưu mẫu học liệu"),
                  icon: <SaveOutlined />,
                }
                ,
                {
                  key: "8",
                  label: t("Tải xuống học liệu", "Tải xuống học liệu"),
                  icon: <DownloadOutlined />,
                },
              ],
              onClick: ({ key }) => {
                if (key === "1") {
                  // edit item
                  handleClick();
                }
                if (key === "2") {
                  typeModule ? setIsOpenEditDrawer(true) : handleClick()
                }
                if (key === "3") {
                  if (props.data?.block?.[0]?.module !== 'text' && props.data?.block?.[0]?.module !== 'quizz' && !typeModule) {
                    downloadUnit(props.data?.block?.[0]?.mainKey)
                  }
                  if (typeModule) {
                    downloadUnitFeedback(props.data?.block?.[0]?.course_unit_id)
                  }
                }
                if (key === "4") {
                  setIsOpenSettingDrawer(true);
                  setIsUnit(true)
                  setIsLesson(false)
                }
                if (key === "5") {
                  // delete item
                  showConfirm();
                }

                if (key === '6') {
                  navigate(`/${routesConfig.settingSupervisionDetail}/${props?.data?.block?.[0]?.id}`)
                }

                if (key === '7') {
                  setIsSaveLearningTemplate(true)
                }
                if (key === "8") {
                  handleDownloadMoocsFile(props.data?.id, "unit", props.data?.name);
                }
              },
            }}
            placement="bottomRight"
          >
            <Button className="action-course">
              <MoreOutlined />
            </Button>
          </Dropdown>
        </Space>
      </div>
      {active && (
        <div className="edit-container">
          <Button onClick={handleCancel}>{t("Hủy", "Hủy")}</Button>
          <Button onClick={handleSave} className="btn-primary">
            <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
          </Button>
        </div>
      )}

      {isAddLearningMaterials &&
        <AddLearningMaterials
          sequenceId={props.data.id}
          setIsOpenDrawer={setIsAddLearningMaterials}
          open={isAddLearningMaterials}
          handleDetail={props.handleGetDetail}
          itemDetail={props?.data}
          isEdit={isEdit}
          id={unitId}
          setIsEdit={setIsEdit}
          multimediaType={multimediaType}

        />
      }
      {isAddLearningMaterialsReference &&
        <AddLearningMaterialsReferences
          sequenceId={props.data.id}
          title="Basic Drawer"
          setIsOpenDrawer={setIsAddLearningMaterialsReference}
          open={isAddLearningMaterialsReference}
          handleDetail={props.handleGetDetail}
          itemDetail={props?.data}
          isEdit={isEdit}
          id={unitId}
          setIsEdit={setIsEdit}
        />
      }
      {isOpenSettingDraw &&
        < ActiveSettingsChaptersDrawer
          id={props.id}
          setIsOpened={setIsOpenSettingDrawer}
          open={isOpenSettingDraw}
          handleDetail={props.handleGetDetail}
          itemDetail={props?.data}
          isLesson={isLesson}
          isUnit={isUnit}
          lessonDetailData={props.lessonDetailData}
        />
      }

      {isOpenEditDraw &&
        <EditExerciseDrawer handleDetail={props.handleGetDetail}
          setLoading={props.setLoading}
          open={isOpenEditDraw} itemDetail={props?.data}
          id={props.data.id} onClose={handleCloseEdit} />
      }

      {/* {isSaveLearningTemplate &&
        <SaveLearningTemplate
          open={isSaveLearningTemplate}
          handleClose={() => setIsSaveLearningTemplate(false)}
          blockId={props.data?.block?.[0]?.id}
        />
      } */}

      <ChooseLearningMaterialModal
        open={isSaveLearningTemplate}
        onCancel={() => setIsSaveLearningTemplate(false)}
        mode="saveTemplate"
        onSaveTemplate={(data) => {
          handleSaveTemplate(data)
        }}
        isSaving={isSaving}
      />
    </>
  );
};

export default UnitCard;